<template>
  <v-container>
    <BaseForm
      :title="$route.meta.title"
      :loading="loading"
      @submit="handleSubmit"
    >
      <template v-slot:content>
        <v-row>
          <v-col cols="12" md="12">
            <v-radio-group
              v-model="user.register_type"
              :row="$vuetify.breakpoint.mdAndUp"
            >
              <v-radio label="Asistido" value="Assisted"></v-radio>
              <v-radio label="Manual" value="Manual"></v-radio>
              <v-radio
                label="Administrador"
                value="Administrator"
                :disabled="hasCustomerRole"
              >
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <!-- USUARIO ASISTIDO -->
        <v-row v-if="user.register_type !== 'Administrator'">
          <v-col cols="12" md="6" v-if="category.client">
            <ValidationProvider
              name="Número de Cuenta"
              :rules="{ required: isAccountCodeRequired }"
              v-slot="{ errors }"
            >
              <v-autocomplete
                ref="accountInput"
                v-model="selectedAccountCodes"
                label="Especifique el número de cuenta"
                append-icon="mdi-magnify"
                item-text="code"
                item-value="code"
                dense
                single-line
                light
                multiple
                chips
                hide-details="auto"
                deletable-chips
                small-chips
                :items="accounts"
                :error-messages="errors[0]"
                @input="handleBeneficiaries"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12" md="6" v-if="user.register_type === 'Assisted'">
            <v-select
              v-model="selectedBeneficiary"
              :items="beneficiaries"
              :label="beneficiariesLabel"
              :loading="loadingBeneficiaries"
              :disabled="loadingBeneficiaries"
              hide-details
              single-line
              light
              dense
              @input="handleAssisted"
            >
              <!-- Slot del item seleccionado -->
              <template #selection="{ item }">
                {{ item.firstname }} {{ item.lastname }}
              </template>
              <!-- Slot del Listado -->
              <template #item="{ item }">
                {{ item.firstname }} {{ item.lastname }}
              </template>
            </v-select>
          </v-col>
        </v-row>
        <!-- DATOS BASICOS -->
        <div class="mt-6">
          <!-- Datos Basicos Titulo -->
          <v-row>
            <v-col>
              <span class="font-weight-medium primary--text"
                >Datos Básicos</span
              >
              <span class="font-italic ml-3">* Campos requeridos</span>
            </v-col>
          </v-row>
          <!-- Formulario de Datos Basicos Usuario -->
          <div class="mt-6">
            <!-- Nombres y Apellidos -->
            <v-row>
              <v-col cols="12" md="6">
                <ValidationProvider
                  name="Nombres"
                  :rules="{ required: !isLegalPerson }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    :label="isLegalPerson ? 'Nombres' : 'Nombres *'"
                    placeholder="Nombres"
                    v-model="user.first_name"
                    dense
                    :error-messages="errors[0]"
                    :disabled="fieldDisabled"
                    autocomplete="nope"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="6">
                <ValidationProvider
                  name="Apellidos"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    label="Apellidos *"
                    placeholder="Apellidos"
                    v-model="user.last_name"
                    dense
                    :error-messages="errors[0]"
                    :disabled="fieldDisabled"
                    autocomplete="nope"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>
            <!-- identificacion y Pasaporte -->
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Identificación"
                  placeholder="Identificación"
                  v-model="user.identification"
                  dense
                  :disabled="fieldDisabled"
                  autocomplete="nope"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Pasaporte"
                  placeholder="Pasaporte"
                  v-model="user.passport"
                  :disabled="fieldDisabled"
                  dense
                  autocomplete="nope"
                />
              </v-col>
            </v-row>
            <!-- Direccion -->
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Dirección"
                  placeholder="Dirección"
                  v-model="user.address"
                  dense
                  autocomplete="nope"
                />
              </v-col>
              <!-- Nacionalidad -->
              <!-- ideal autocomplete con valores de nacionalidad comunes a la bdd de AV -->
              <v-col cols="12" md="6">
                <v-autocomplete
                  label="Nacionalidad"
                  placeholder="Nacionalidad"
                  v-model="user.nationality"
                  dense
                  clearable
                  item-text="name_es"
                  item-value="name_es"
                  :items="countries.countries"
                  :disabled="fieldDisabled"
                >
                  <!-- Seleccion -->
                  <template v-slot:selection="data">
                    {{ data.item.name_es }} - {{ data.item.code }}
                  </template>
                  <!-- listado -->
                  <template #item="{ item }">
                    {{ item.name_es }} - {{ item.code }}
                  </template>
                </v-autocomplete>
                <!-- autocomplete="nope" -->
              </v-col>
            </v-row>
            <!-- Telefono Fijo y Telefono Movil -->
            <v-row>
              <v-col cols="12" md="6">
                <phone-input
                  label="Teléfono Fijo"
                  placeholder="Teléfono Fijo"
                  v-model="user.phone"
                  :disabled="fieldDisabled"
                  dense
                />
              </v-col>
              <v-col cols="12" md="6">
                <!-- <code>{{user.mobile_phone}}</code> -->
                <phone-input
                  label="Teléfono Móvil"
                  placeholder="Teléfono Móvil"
                  v-model="user.mobile_phone"
                  dense
                />
              </v-col>
            </v-row>
            <!-- Correo Electrónico y Confirmacion de Correo -->
            <v-row>
              <v-col cols="12" md="6">
                <ValidationProvider
                  name="correo"
                  rules="required|email|confirmed:emailConfirmation|max:255"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    label="Correo Electrónico *"
                    placeholder="Correo Electrónico"
                    v-model="user.email"
                    dense
                    :error-messages="errors[0]"
                    autocomplete="nope"
                    :disabled="user.id !== undefined"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="6">
                <ValidationProvider
                  name="confirm correo"
                  v-slot="{ errors }"
                  rules="required|email|max:255"
                  vid="emailConfirmation"
                >
                  <v-text-field
                    label="Confirmación Correo Electrónico *"
                    placeholder="Confirmación Correo Electrónico"
                    v-model="emailConfirmation"
                    dense
                    :error-messages="errors[0]"
                    autocomplete="nope"
                    :disabled="user.id !== undefined"
                    @click.right.prevent
                    @copy.prevent
                    @paste.prevent
                  />
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row v-if="user.register_type !== 'Administrator'">
              <v-col cols="12" md="6">
                <ValidationProvider name="Broker" rules="" v-slot="{ errors }">
                  <v-select
                    :items="brokers"
                    v-model="user.broker_id"
                    item-text="name"
                    item-value="id"
                    label="Seleccione el Broker"
                    dense
                    single-line
                    light
                    :error-messages="errors[0]"
                    clearable
                  ></v-select>
                </ValidationProvider>
              </v-col>
            </v-row>
            <!-- Correo Electrónico alternativo y Confirmacion de Correo -->
          </div>
          <!-- Roles de Usuario Titulo -->
          <!-- Roles de Usuario Casilla -->
          <div class="mt-6">
            <v-tabs active-class="tab-active">
              <v-tab v-if="!fields.admin_check">
                Roles Área Pública
              </v-tab>
              <v-tab>
                Roles Administradores
              </v-tab>
              <v-tab>
                Roles Onboarding
              </v-tab>
              <!-- <v-tab>
                Roles Orders
              </v-tab> -->
              <v-tab-item v-if="!fields.admin_check" class="py-2">
                <v-checkbox
                  v-for="roleClient in roles.rolesClient"
                  v-model="user.roles"
                  :key="roleClient.name"
                  :label="roleClient.name"
                  :value="roleClient"
                  class="mt-1"
                  hide-details="auto"
                />
              </v-tab-item>
              <v-tab-item class="py-2">
                <v-checkbox
                  v-for="roleAdmin in roles.rolesAdmin"
                  v-model="user.roles"
                  :key="roleAdmin.name"
                  :label="roleAdmin.name"
                  :value="roleAdmin"
                  class="mt-1"
                  hide-details="auto"
                />
              </v-tab-item>
              <v-tab-item v-if="roles.rolesOnboarding.length" class="py-2">
                <v-checkbox
                  v-for="roleOnboarding in roles.rolesOnboarding"
                  v-model="user.roles"
                  :key="roleOnboarding.name"
                  :label="roleOnboarding.name"
                  :value="roleOnboarding"
                  class="mt-1"
                  hide-details="auto"
                />
              </v-tab-item>
            </v-tabs>
          </div>
          <v-divider class="my-4" />
          <v-row v-if="user.register_type !== 'Administrator'">
            <v-col>
              <span class="text-h6 font-weight-medium primary--text">Información Adicional</span>
            </v-col>
          </v-row>
          <!-- Categorias inputs -->
          <div v-if="user.register_type !== 'Administrator'">
            <!-- Autoridad -->
            <v-row dense>
              <v-col
                cols="12"
                md="4"
                class="d-flex flex-row justify-space-between align-center"
              >
                <v-switch
                  label="Autoridad"
                  v-model="category.authority"
                  @change="handleAuthorityCheckbox"
                  dense
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row v-if="category.authority" dense class="mb-4">
              <v-col cols="12" md="6">
                <v-autocomplete
                  :items="authorityLevels"
                  item-text="name"
                  item-value="code"
                  v-model="user.authorityLevelsCode"
                  class="px-3"
                  label="Seleccione Sub Categoría"
                  hide-details="auto"
                  dense
                  single-line
                  light
                  @input="handleAuthorityLevels"
                />
              </v-col>
              <v-col cols="12" md="6">
                <ValidationProvider
                  name="Grupo"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-autocomplete
                    v-model="selectedAuthorityCode"
                    :items="authorities"
                    :loading="loadingAuthorities"
                    :label="authoritiesLabel"
                    :disabled="fields.authorities"
                    item-value="code"
                    item-text="name"
                    hide-details="auto"
                    class="px-3"
                    dense
                    single-line
                    light
                    :error-messages="errors[0]"
                  >
                    <!-- Seleccion -->
                    <template v-slot:selection="data">
                      ({{ data.item.code }}) {{ data.item.firstname }} {{ data.item.lastname }}
                    </template>
                    <!-- listado -->
                    <template #item="{ item }">
                      ({{ item.code }}) {{ item.firstname }} {{ item.lastname }}
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </v-col>
            </v-row>
            <!-- Grupo -->
            <v-row dense>
              <v-col
                cols="12"
                md="4"
                class="d-flex flex-row justify-space-between align-center"
              >
                <v-switch
                  label="Grupo"
                  v-model="category.group"
                  hide-details
                  dense
                  @change="loadGroups"
                />
              </v-col>
            </v-row>
            <v-row v-if="category.group" dense>
              <v-col cols="12" md="6">
                <ValidationProvider
                  name="Grupo"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    v-model="selectedAccountGroup"
                    label="Seleccione Grupo"
                    class="px-3"
                    item-text="name"
                    item-value="code"
                    hide-details="auto"
                    :items="accountGroups"
                    :loading="loadingGroups"
                    :error-messages="errors[0]"
                    dense
                    single-line
                    light
                  />
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row class="mt-5">
              <v-col cols="12" md="2" class="d-flex justify-start">
                <v-select
                  v-model="user.languageCode"
                  :items="languages"
                  label="Lenguaje"
                  item-text="name"
                  item-value="code"
                  prepend-icon="mdi-web"
                />
              </v-col>
              <v-col cols="12" md="10" class="d-flex justify-end">
                <v-switch
                  label="Activo"
                  v-model="user.active"
                  color="primary"
                ></v-switch>
              </v-col>
            </v-row>
          </div>
        </div>
      </template>
    </BaseForm>
  </v-container>
</template>

<script>
import BaseForm from '@/components/commons/BaseForm'
import UserService from '@/services/user'
import RoleService from '@/services/role'
import AccountService from '@/services/external/accounts'
// import AccountBeneficiariesService from '@/services/external/accountBeneficiaries'
import AuthorityLevelsService from '@/services/external/authorityLevels'
import AuthoritiesService from '@/services/external/authorities'
// import AccountGroupsService from '@/services/external/accountGroups'
import PhoneInput from '@/components/commons/PhoneInput'
import Countries from '@/api/countries'
import LanguageService from '@/services/language'
import BrokerService from '@/services/broker'
import AccountBeneficiariesService from '@/services/external/accountBeneficiaries'
import { nextTick } from 'vue'
import AccountGroupsService from '@/services/external/accountGroups'

export default {
  components: { BaseForm, PhoneInput },
  data() {
    return {
      loading: false,
      user: {
        first_name: '',
        last_name: '',
        address: '',
        passport: '',
        identification: '',
        nationality: '',
        avobjects: [],
        authorityLevelsCode: null,
        languageCode: 'es',
        broker_id: null,
        roles: [],
        register_type: 'Assisted',
        active: true
      },
      emailConfirmation: '',
      roles: {
        rolesAdmin: [],
        rolesClient: [],
        rolesOnboarding: []
        // rolesOrder: []
      },
      selectedAccountCodes: [],
      accounts: [],
      fields: {},
      beneficiaries: [],
      selectedBeneficiary: null,
      loadingBeneficiaries: false,
      selectedAccountGroup: null,
      selectedAuthorityCode: null,
      authorityLevels: [],
      loadingAuthorities: false,
      loadingGroups: false,
      authorities: [],
      accountGroups: [],
      category: {
        client: true,
        authority: false,
        group: false
      },
      countries: [],
      languages: [],
      brokers: [],
      debounceTimer: null
    }
  },
  async created() {
    this.loading = true
    try {
      const countries = Countries
      this.countries = countries
      await this.initData()
      const id = this.$route.params.id

      //Edit
      if (id) {
        await this.initUserData(id)
      }
    } catch (error) {
      console.log(error)
      this.$dialog.message.error('No se pudo obtener los datos de las cuentas')
    } finally {
      nextTick(() => this.$refs.accountInput?.focus())
      this.loading = false
    }
  },
  beforeDestroy() {
    clearTimeout(this.debounceTimer)
  },
  methods: {
    async initData() {
      try {
        await Promise.all([
          await this.populateRoles(),
          await this.populateAccounts(),
          await this.populateLanguages(),
          await this.populateBrokers()
        ])
      } catch (error) {
        console.error('Error loading data:', error)
      }
    },
    clearFields() {
      this.user.first_name = ''
      this.user.last_name = ''
      this.user.address = ''
      this.user.passport = ''
      this.user.identification = ''
      this.user.nationality = ''
      this.user.phone = ''
      this.user.email = ''
      this.emailConfirmation = ''
    },
    async handleSubmit() {
      if (this.user.roles.length === 0) {
        this.$dialog.message.error('No ha escogido roles para el usuario')
        return false
      }

      this.user.customer = false

      // Set User Roles
      this.user.admin = this.user.roles.some(item => item.type === 'Admin')
      this.user.customer = this.user.roles.some(item => item.type === 'Customer')

      // Check Admin And Customer Roles
      if (this.user.customer && this.user.admin) {
        const response = await this.$dialog.warning({ text: '¿ Desea registrar este usuario ? Tiene roles de Área Pública y Administrador.' })
        if (!response) {
          return false
        }
      }

      this.loading = true
      // AVObjects
      this.user.avobjects = [] // Clear avObjects
      for (const code of this.selectedAccountCodes) {
        const accountCode = { typeCode: 'accountCode', code }
        this.user.avobjects.push(accountCode)
      }

      if (this.selectedAccountGroup) {
        const groupCode = { typeCode: 'groupCode', code: this.selectedAccountGroup }
        this.user.avobjects.push(groupCode)
      }

      if (this.selectedAuthorityCode) {
        const authorityCode = { typeCode: 'authorityCode', code: this.selectedAuthorityCode }
        this.user.avobjects.push(authorityCode)
      }

      try {
        await UserService.save(this.user)
        this.$dialog.notify.success('Registro guardado con éxito.')
        this.$router.push({ name: 'Users' })
      } catch (error) {
        if (error.response?.data?.code === 23000) {
          this.$dialog.message.error(`No se pudo guardar el registro. El email <strong>${this.user.email}</strong> ya existe.`)
        } else {
          this.$dialog.message.error('No se pudo guardar el registro.')
        }
      } finally {
        this.loading = false
      }
    },
    async handleBeneficiaries() {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(async () => {
        if (this.user?.register_type === 'Assisted') {
          this.loadingBeneficiaries = true
          if (this.selectedBeneficiary) {
            this.clearFields()
          }

          try {
            const fetchPromises = this.selectedAccountCodes.map(code => {
              return AccountBeneficiariesService.find(code)
            })

            // Call API Fetch on Parallel
            const responses = await Promise.all(fetchPromises)

            const items = responses.flat()

            // Remove duplicates
            const uniqueBeneficiariesMap = new Map()
            items.forEach(item => {
              const uniqueKey = `${item.firstname}|${item.lastname}|${item.passport}|${item.nationality}`
              uniqueBeneficiariesMap.set(uniqueKey, item)
            })

            this.beneficiaries = Array.from(
              uniqueBeneficiariesMap.values()
            ).sort((a, b) => a.firstname.localeCompare(b.firstname))
          } catch (error) {
            console.log(error)
            this.beneficiaries = []
            this.selectedBeneficiary = null
          } finally {
            this.loadingBeneficiaries = false
          }
        }
      }, 700)
    },
    async initUserData(id) {
      this.user = await UserService.find(id)
      // Email confirm
      this.emailConfirmation = this.user.email

      // Get AccountCodes
      this.selectedAccountCodes = this.user.avobjects
        .filter(item => item.typeCode === 'accountCode')
        .map(item => item.code)

      // Map roles
      this.user.roles = this.user.roles.map(item => ({ name: item.name, type: item.type }))

      // Set AVObjects
      if (this.user.authorityLevelsCode !== null) {
        await this.populateAuthorityLevels()
        await this.handleAuthorityLevels(this.user.authorityLevelsCode)
        const authorityCode = this.user.avobjects.find(item => item.typeCode === 'authorityCode')
        if (authorityCode) {
          this.selectedAuthorityCode = parseInt(authorityCode.code)
        }
        this.category.authority = true
      }

      const accountGroup = this.user.avobjects.find(item => item.typeCode === 'groupCode')
      if (accountGroup) {
        await this.populateAccountGroups()
        this.category.group = true
        this.selectedAccountGroup = accountGroup.code
      }

      if (this.user.register_type === 'Assisted') {
        await this.handleBeneficiaries()
      }
    },
    loadGroups(check) {
      if (check && this.accountGroups.length === 0) {
        this.populateAccountGroups()
      } else if (!check) {
        this.selectedAccountGroup = null
      }
    },
    async populateRoles() {
      const { data } = await RoleService.fetch({ 'filter[type]': 'Admin,Customer,Onboarding' })

      this.roles.rolesAdmin = data.data
        .filter(item => item.type === 'Admin')
        .map(item => ({ name: item.name, type: item.type }))

      this.roles.rolesClient = data.data
        .filter(item => item.type === 'Customer')
        .map(item => ({ name: item.name, type: item.type }))

      this.roles.rolesOnboarding = data.data
        .filter(item => item.type === 'Onboarding')
        .map(item => ({ name: item.name, type: item.type }))

      // this.roles.rolesOrder = data.data
      //   .filter(item => item.type === 'Order')
      //   .map(item => ({ name: item.name, type: item.type }))
    },
    async populateAccounts() {
      const { data } = await AccountService.fetch()
      this.accounts = data
    },
    async populateBrokers() {
      const { data } = await BrokerService.fetch()
      this.brokers = data.data
    },
    async populateAuthorityLevels() {
      const { data } = await AuthorityLevelsService.fetch()
      this.authorityLevels = data
    },
    async handleAuthorityLevels(code) {
      this.loadingAuthorities = true
      if (code || code === 0) {
        try {
          this.authorities = []
          // if code is 4 (Asistente), get all directors (code 0)
          const authorityCode = code === 4 ? 0 : code.toString()
          const { data } = await AuthoritiesService.fetch({
            authorityLevelCode: authorityCode
          })
          this.authorities = data.map(item => ({
            ...item,
            name: item.firstname + ' ' + item.lastname
          }))
        } catch (error) {
          console.log(error)
          this.$dialog.message.error('No se pudo obtener autoridades')
        } finally {
          this.loadingAuthorities = false
          this.fields.authorities = false
        }
      } else {
        this.loadingAuthorities = false
        this.authorities = []
        this.fields.authorities = true
      }
    },
    async handleAuthorityCheckbox(check) {
      if (check && this.authorityLevels.length === 0) {
        await this.populateAuthorityLevels()
      } else if (!check) {
        this.selectedAuthorityCode = null
        this.authorities = []
        this.user.authorityLevelsCode = null
      }
    },
    async handleAssisted(value) {
      this.user.first_name = value.firstname
      this.user.last_name = value.lastname
      this.user.address = value.address1
      this.user.passport = value.passport
      this.user.identification = value.documentId
      this.user.nationality = value.nationality
      this.user.phone = value.phoneNumber
      if (!this.user.id) {
        const email = value.email
        this.$set(this.user, 'email', email)
        this.emailConfirmation = this.user.email
      }
    },
    async populateLanguages() {
      const { data } = await LanguageService.fetch()
      this.languages = data.data
    },
    async populateAccountGroups() {
      const { data } = await AccountGroupsService.fetch()
      this.accountGroups = data.sort((a, b) => a.name.localeCompare(b.name))
    }
  },
  computed: {
    fieldDisabled() {
      return this.user.register_type === 'Assisted'
    },
    beneficiariesLabel() {
      if (this.loadingBeneficiaries) {
        return 'Cargando beneficiarios...'
      }
      if (this.beneficiaries.length === 1) {
        return `Las cuentas posee ${this.beneficiaries.length} Beneficiarios, haga su selección`
      } else if (this.beneficiaries.length === 0) {
        return `Las cuentas no poseen Beneficiarios`
      } else if (!this.beneficiaries) {
        return `Lista de Beneficiarios`
      } else {
        return `Las cuentas poseen ${this.beneficiaries.length} Beneficiarios, haga su selección`
      }
    },
    authoritiesLabel() {
      if (this.authorities.length === 1) {
        return `La Categoría posee ${this.authorities.length} Autoridad, haga su selección`
      } else if (this.authorities.length === 0) {
        return `La Categoría no posee Autoridades`
      } else if (!this.authorities) {
        return `Lista de Autoridades`
      } else {
        return `La Categoría posee ${this.authorities.length} Autoridades, haga su selección`
      }
    },
    hasCustomerRole() {
      return this.user.roles.some(item => item.type === 'Customer')
    },
    isLegalPerson() {
      return this.selectedBeneficiary?.accountType === 'Juridica'
    },
    isAccountCodeRequired() {
      return !this.selectedAccountGroup && !this.selectedAuthorityCode
    }
  }
}
</script>

<style>
.v-tab {
  text-transform: none !important;
  font-weight: bold;
}
.category_row {
  padding: 0 !important;
}

.radio_buttons {
  display: flex;
  flex-direction: row;
}
</style>
